import { render } from "./ShowFootnotesSwitch.vue?vue&type=template&id=5abedecf&scoped=true"
import script from "./ShowFootnotesSwitch.vue?vue&type=script&lang=js"
export * from "./ShowFootnotesSwitch.vue?vue&type=script&lang=js"

import "./ShowFootnotesSwitch.vue?vue&type=style&index=0&id=5abedecf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abedecf"]])

export default __exports__